/**
 * A sticky column will scroll until it reaches the bottom of the columns content and then stick
 * the bottom of the column to the bottom of the viewport as you continue to scroll.
 *
 * It uses position: sticky which should work for browsers greater than IE11.  It must take into
 * account viewport height and content height to stick it to the correct place which means it
 * must listen for window resize events and uses ContainerSize for content height changes.
 */

import { h, Component } from 'preact';
import style from './style';
import Column from '../';
import { ContainerSize } from '@cube/blocks';

export default class ColumnSticky extends Component {

	columnRef = null;

	intervalHandle = null;

	intervalCount = 0;

	intervalMax = 6;

	state = {
		height: 0
	};

	setHeight = () => {
		if (this.intervalHandle) {
			window.clearInterval(this.intervalHandle);
			this.intervalHandle = null;
			this.intervalCount = 0;
		}

		this.intervalHandle = window.setInterval(() => {
			if (this.columnRef && this.columnRef.clientHeight) {
				let viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
				let height = this.columnRef.clientHeight - viewportHeight;

				if (height !== this.state.height) {
					this.setState({ height: this.columnRef.clientHeight - window.innerHeight });
				}
			}

			if (this.intervalCount >= this.intervalMax) {
				window.clearInterval(this.intervalHandle);
				this.intervalHandle = null;
			}
		}, 1000);
	};

	componentDidMount() {
		this.setHeight();
		window.addEventListener('resize', this.setHeight);
	}

	componentWillUnmount() {
		if (this.intervalHandle) {
			window.clearInterval(this.intervalHandle);
		}
		window.removeEventListener('resize', this.setHeight);
	}

	render({ children, ...props }, { height }) {
		let styles = {};

		if (height) {
			styles.top = -height;
		}

		return (
			<Column class={props.class}>
				<div class={style.sticky} ref={columnRef => this.columnRef = columnRef} style={styles} >
					<ContainerSize width={false} onBeforeResize={this.setHeight}>
						{children}
					</ContainerSize>
				</div>
			</Column>
		);
	}
}
